import { Trans } from '@lingui/macro';
import { ReactComponent as DiscordLogo } from 'assets/logos/socials/discord_logo.svg';
import { ReactComponent as OpenSeaLogo } from 'assets/logos/socials/opensea_logo.svg';
import { ReactComponent as TwitterLogo } from 'assets/logos/socials/twitter_logo.svg';
import React from 'react';

import * as S from './Socials.styles';

const Socials: React.FC = () => {
  return (
    <S.SocialsWrapper>
      <S.SocialDisabledLink>
        <DiscordLogo />
        <S.ComingSoonSocial>Coming Soon</S.ComingSoonSocial>
      </S.SocialDisabledLink>
      <S.SocialDisabledLink>
        <OpenSeaLogo />
        <S.ComingSoonSocial>
          <Trans>Coming Soon</Trans>
        </S.ComingSoonSocial>
      </S.SocialDisabledLink>
      <S.SocialLink href="https://twitter.com/binary1010_BRX" target="_blank" rel="noreferrer">
        <TwitterLogo />
      </S.SocialLink>
    </S.SocialsWrapper>
  );
};

export default Socials;
